import { render, staticRenderFns } from "./ExchangeIframe.vue?vue&type=template&id=9ee176c2&"
import script from "./ExchangeIframe.vue?vue&type=script&lang=ts&"
export * from "./ExchangeIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports